import { FetchCriteriaModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
export class ManageProductRequest {
    fetchCriteria: FetchCriteriaModel;
    // brokerAccountClientIds: Array<string>;
    serviceStatus: string;

    constructor() {
        this.fetchCriteria = undefined;
        // this.brokerAccountClientIds = undefined;
        this.serviceStatus = undefined;
    }
}
